import axiosInstance from "./AxiosInstance";

const getCurrentTime = () => {
  const now = new Date();
  return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(
    2,
    "0"
  )}-${String(now.getDate()).padStart(2, "0")} ${String(
    now.getHours()
  ).padStart(2, "0")}:${String(now.getMinutes()).padStart(2, "0")}:${String(
    now.getSeconds()
  ).padStart(2, "0")}`;
};


export const markSleepAsDone = async ({ date, wake_up, avg_sleep_duration }) => {
  try {
    const response = await axiosInstance.post("api/sleep-coach/mark-as-done", {
      date,
      mark_as_done: true,
      wake_up,
      avg_sleep_duration,
    });
    return response; 
  } catch (error) {
    console.error("Error marking sleep coach as done:", error);
    throw error;
  }
};


export const submitSleepEntries = async (preferences) => {
  try {
    const response = await axiosInstance.post("api/sleep/coach/entries", {
      preferences,
    });
    return response.data;
  } catch (error) {
    console.error("Error submitting sleep coach entries:", error);
    throw error;
  }
};

export const createSleepPlan = async () => {
  try {
    const response = await axiosInstance.post("api/sleep-coach/create/plan",{
      start_time: getCurrentTime(),
    });
    return response.data;
  } catch (error) {
    console.error("Error creating sleep coach plan:", error);
    throw error;
  }
};

export const fetchSleepSteps = async () => {
  try {
    const response = await axiosInstance.get("api/sleep/coach/entries");
    return response.data;
  } catch (error) {
    console.error("Error fetching sleep coach steps:", error);
    throw error;
  }
};

export const fetchSleepData = async () => {
  try {
    const response = await axiosInstance.get("api/sleep-coach");
    return response; 
  } catch (error) {
    console.error("Error fetching sleep coach data:", error);
    throw error;
  }
};